export default __webpack_public_path__ + "static/media/wedding4.4352928d.webp";